import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { AmazonS3CompatibleLocation } from 'app/model/dataset/location/amazon-s3-compatible.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonS3CompatibleLocation),
    adapts: {
        type: '*',
        bucketName: '*',
        folderPath: '*',
        fileName: '*'
    }
})
export class AmazonS3CompatibleLocationAdapter extends FileLocationAdapter<AmazonS3CompatibleLocation, Model.DatasetLocation> {
    public _toResource(store: AmazonS3CompatibleLocation): Model.AmazonS3CompatibleLocation {
        const resource: Model.AmazonS3CompatibleLocation = {
            type: AmazonS3CompatibleLocation.MODEL.name,
            bucketName: ValueAdapter.toResource(store, AmazonS3CompatibleLocation.CONTAINER) || undefined,
            folderPath: ValueAdapter.toResource(store, AmazonS3CompatibleLocation.FOLDER_PATH) || undefined,
            fileName: ValueAdapter.toResource(store, AmazonS3CompatibleLocation.FILE_NAME) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.AmazonS3CompatibleLocation, owner: Named): AmazonS3CompatibleLocation {
        const model = Owned.create<AmazonS3CompatibleLocation>(AmazonS3CompatibleLocation.MODEL, owner);
        ValueAdapter.toModel(model, AmazonS3CompatibleLocation.CONTAINER, resource.bucketName);
        ValueAdapter.toModel(model, AmazonS3CompatibleLocation.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, AmazonS3CompatibleLocation.FILE_NAME, resource.fileName);
        return model;
    }
}
